import { createContext, useContext } from "react";

import { UseQueryResult } from "@tanstack/react-query";

import { PurchaseOrder } from "@models/PurchaseOrder";
import { PurchaseOrderVariant } from "@models/PurchaseOrderVariant";

export const PurchaseOrderContext = createContext<{
  purchaseOrder: PurchaseOrder;
  purchaseOrderVariants: PurchaseOrderVariant[];
  poQuery: UseQueryResult<PurchaseOrder>;
  povQuery: UseQueryResult<PurchaseOrderVariant[]>;
} | null>(null);

export const usePurchaseOrder = () => {
  const context = useContext(PurchaseOrderContext);
  if (!context) {
    throw new Error(
      "usePurchaseOrder must be used within a PurchaseOrderContextProvider"
    );
  }
  return context;
};
